const WEB_VITALS_SAMPLE_RATE = 0.1;
const WEB_VITALS_SAMPLE_STORAGE_KEY = 'gld_web_vitals_sample_v1';

let monitoringScheduled = false;

export const isProductionStorefront = (hostname) =>
  hostname === 'gld.com' || hostname === 'www.gld.com';

export const shouldSampleWebVitals = ({
  storage,
  random = Math.random,
  sampleRate = WEB_VITALS_SAMPLE_RATE,
} = {}) => {
  try {
    const storedDecision = storage?.getItem(WEB_VITALS_SAMPLE_STORAGE_KEY);

    if (storedDecision === 'included') {
      return true;
    }

    if (storedDecision === 'excluded') {
      return false;
    }
  } catch (_error) {
    // Storage can be disabled. Sampling still works for the current page.
  }

  const included = random() < sampleRate;

  try {
    storage?.setItem(
      WEB_VITALS_SAMPLE_STORAGE_KEY,
      included ? 'included' : 'excluded'
    );
  } catch (_error) {
    // No persistence is required for the measurement to work.
  }

  return included;
};

const getSessionStorage = () => {
  try {
    return window.sessionStorage;
  } catch (_error) {
    return undefined;
  }
};

const initializeMonitoring = () => {
  import(
    /* webpackChunkName: "monitoring_web-vitals" */ './WebVitalsMonitoring'
  )
    .then(({ initializeWebVitalsMonitoring }) =>
      initializeWebVitalsMonitoring()
    )
    .catch(() => {});
};

const loadMonitoringWhenIdle = () => {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(initializeMonitoring, { timeout: 5000 });
    return;
  }

  window.setTimeout(initializeMonitoring, 1500);
};

export const scheduleWebVitalsMonitoring = () => {
  if (
    monitoringScheduled ||
    !isProductionStorefront(window.location.hostname) ||
    window.Shopify?.designMode ||
    !shouldSampleWebVitals({ storage: getSessionStorage() })
  ) {
    return;
  }

  monitoringScheduled = true;

  if (document.readyState === 'complete') {
    loadMonitoringWhenIdle();
  } else {
    window.addEventListener('load', loadMonitoringWhenIdle, { once: true });
  }
};

export { WEB_VITALS_SAMPLE_RATE, WEB_VITALS_SAMPLE_STORAGE_KEY };
